module.exports = {"430224002":"下东街道","430224003":"思聪街道","430224004":"洣江街道","430224005":"云阳街道","430224101":"界首镇","430224103":"湖口镇","430224105":"马江镇","430224106":"高陇镇","430224109":"虎踞镇","430224111":"枣市镇","430224112":"火田镇","430224113":"严塘镇","430224115":"秩堂镇","430224116":"腰潞镇","430224203":"舲舫乡","430224213":"桃坑乡","430224404":"汉背","430224500":"茶陵县红色农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430224.json
// module id = 1667
// module chunks = 0